export const GET_ORGANIZATIONS_REQUEST = "GET_ORGANIZATIONS_REQUEST";
export const GET_ORGANIZATIONS_SUCCESS = "GET_ORGANIZATIONS_SUCCESS";
export const GET_ORGANIZATIONS_FAILURE = "GET_ORGANIZATIONS_FAILURE";
